import { ErrorApi } from '../identidad/cliente-identidad.js'
import { cerrarCarga, mostrarCarga, notificar } from '../fundacion/alertas.js'
import { generarReporte } from './cliente-reportes.js'
const elemento = <T extends Element>(selector: string): T => {
  const dato = document.querySelector<T>(selector)
  if (!dato) throw new Error(`No existe ${selector}`)
  return dato
}
export function mostrarReportes(roles: string[]): void {
  if (
    !roles.some((rol) => ['COORDINADOR_GENERAL', 'COORDINADOR_ASESORES', 'ASESOR'].includes(rol))
  ) {
    elemento('#panel-reportes').classList.add('d-none')
    return
  }
  elemento('#panel-reportes').classList.remove('d-none')
  elemento('#formulario-reporte').classList.toggle(
    'd-none',
    !roles.some((rol) => ['COORDINADOR_GENERAL', 'COORDINADOR_ASESORES', 'ASESOR'].includes(rol)),
  )
  const esGeneral = roles.includes('COORDINADOR_GENERAL')
  const esCoordinadorAsesores = roles.includes('COORDINADOR_ASESORES')
  const esAsesor = roles.includes('ASESOR')
  document.querySelectorAll<HTMLOptionElement>('#tipo-reporte option').forEach((opcion) => {
    opcion.hidden =
      (opcion.value === 'REP-005' && !esGeneral) ||
      (opcion.value === 'REP-006' && !esCoordinadorAsesores) ||
      (opcion.value === 'REP-004' && esAsesor && !esGeneral && !esCoordinadorAsesores)
  })
  const selector = elemento<HTMLSelectElement>('#tipo-reporte')
  const actual = selector.selectedOptions[0]
  if (actual?.hidden) selector.value = 'REP-001'
  elemento('#panel-reportes').scrollIntoView({ behavior: 'smooth', block: 'start' })
}
elemento<HTMLFormElement>('#formulario-reporte').addEventListener('submit', (evento) => {
  evento.preventDefault()
  const formulario = evento.currentTarget as HTMLFormElement
  const tipo = elemento<HTMLSelectElement>('#tipo-reporte').value
  const boton = formulario.querySelector<HTMLButtonElement>('button[type=submit]')!
  boton.disabled = true
  mostrarCarga('Generando y preparando la descarga…')
  void generarReporte(tipo, { limite: 500 })
    .then((reporte) => {
      const enlace = document.createElement('a')
      enlace.href = `/api/v1/reportes/${reporte.id}/archivo`
      enlace.download = reporte.nombre_archivo
      document.body.append(enlace)
      enlace.click()
      enlace.remove()
      notificar(`Reporte ${reporte.nombre_archivo} generado y descargado.`)
    })
    .catch((error: unknown) => {
      notificar(
        error instanceof ErrorApi ? error.message : 'No fue posible generar el reporte.',
        'error',
      )
    })
    .finally(() => {
      boton.disabled = false
      cerrarCarga()
    })
})
